import Pages from "layouts/Pages/Pages.jsx";
import Entry from "layouts/Entry/Entry.jsx";
import LoginPage from "../layouts/Pages/LoginPage";


var indexRoutes = [
  { path: "/pages", name: "Pages", component: Pages, needAuth: false },
  { path: "/login", name: "LoginPage", component: LoginPage, needAuth: false },
  { path: "/", name: "Home", component: Entry, needAuth: true }
];

export default indexRoutes;


// WEBPACK FOOTER //
// ./src/routes/index.jsx